var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail"},[_c('creation-detail',{attrs:{"info":_vm.info},on:{"refreshBtn":_vm.getDetails}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }